import proxy from '../../build_config'
import reverseProxy from '../config/reverseProxy'
import RegisterControllerUI from './RegisterUI'
import '../../css/LoginSystem/bootstrapLogin.css'
import eyeOpenIcon from "../../images/eyeOpen.svg";
import eyeCloseIcon from "../../images/eyeClose.svg";
import landing_img from '../../images/operator_login_background.png'
import company_logo from '../../images/vm_routes_logo.svg'
import SystemNotification from '../UiControllers/SystemNotification'
import IndexDb from '../E2E/IndexDb'

class LoginUiController {

    constructor(globalStore, container) {

        this.globalStore = globalStore || {}
        this.container = container || document.querySelector('.project-main')
        this.systemNotification = new SystemNotification({ globalStore: globalStore })
        this.rigisterForm = new RegisterControllerUI(globalStore)
        this.resendBtn = false
        this._init()
    }

    _init() {

        this.ui = this._makeloginUi()

        this.addEvents()

    }


    _makeloginUi() {

        this.container.innerHTML = `
        <img class="login-background-image" src="${landing_img}" />
        <div class="login-upper-container">
            <div class="login-inner-container operator-login-tab">
                
                <img src="${company_logo}" alt="" class="logo-image">
                
                <p class="login-title-tab">OPERATOR LOGIN</p>

                <form action="#!" class="login-form-tab">

                    <label class="login-label-tag">Email Address</label>
                    <div class="login-input-container" id='login_email_parent'>
                        <input class="login-user-input" type="email" name="email" id="email" required placeholder="email@example.com">
                        <div class='project-login-email-error-msgs'>
                            <i class='bx bxs-info-circle'></i>
                            <span id='email-error-msg'> Please enter your email address using the format name@example.com</span>
                        </div>
                    </div>
        
                    <label class="login-label-tag">Password</label>
                    <div class="login-input-container" id='login_password_parent'>
                        <input class="login-user-input" name="password" id="password" required type="password" placeholder="Enter Password">
                        <img class="login-password-icon" src="${eyeCloseIcon}">
                    </div>

                </form>
    
                <div class="login-add-on-buttons">
                    <div class="remember-me-container">
                        <input type="checkbox" value="lsRememberMe" class="remember-me" id="rememberMe"> <label
                            for="rememberMe">Remember me</label>
                    </div>
                    
                    <a href="#!" id="forgotBtn" class="login-forgot-password">Forgot Password ?</a>
                </div>

                <div class="login-submit-button-container">
                    <button class="login-submit-button" name="login" id="login" value="Login">Login</button>
                </div>

                <p class="login-wrapper-footer-text register-here-btn-new">Don't have an account? <a href="#!" class="text-reset" id="registerBtn">Register here</a></p>
    
            </div>
        </div>
            `

        return this.container

    }


    addEvents() {

        let loginForm = this.ui.querySelector('form')
        let registerBtn = this.ui.querySelector('#registerBtn')
        let forgotBtn = this.ui.querySelector('#forgotBtn')
        let loginBtn = this.ui.querySelector('#login')
        let input_email = this.ui.querySelector('#email')
        let input_password = this.ui.querySelector('#password')
        let email_error_msgs = this.ui.querySelector('.project-login-email-error-msgs')

        let showPassword = this.ui.querySelector('.login-password-icon');

        showPassword.addEventListener('click', () => {
            if (showPassword.src == eyeOpenIcon) {
                showPassword.src = eyeCloseIcon;
                input_password.type = "password";
            } else {
                showPassword.src = eyeOpenIcon;
                input_password.type = "text";
            }
        })

        function verifyEmail(value) {

            return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))

        }

        let login_btn_event = () => {

            let isUpperAlpha_email = !new RegExp('(?=.*[A-Z])').test(input_email.value)

            if (verifyEmail(input_email.value) && isUpperAlpha_email && input_password.value.length) {

                // if (loginBtn.classList.contains('login-submit-button-disable')) loginBtn.classList.remove('login-submit-button-disable')
            }
            else {
                // if (!loginBtn.classList.contains('login-submit-button-disable')) loginBtn.classList.add('login-submit-button-disable')
            }
        }

        input_password?.addEventListener("input", function () {
            login_btn_event()
        });
        input_email?.addEventListener("input", function () {
            login_btn_event()
        });

        input_email?.addEventListener("change", function () {

            let isUpperAlpha = new RegExp('(?=.*[A-Z])').test(input_email.value)

            if (!verifyEmail(input_email.value) || isUpperAlpha) {
                email_error_msgs.style.display = 'flex'
            }
            else {
                email_error_msgs.style.display = 'none'
            }

        });

        function generateRandomId(length = 16) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        }
        loginBtn.addEventListener('click', async (e) => {
            e.preventDefault()

            let email = loginForm.querySelector('input[name="email"]').value
            let password = loginForm.querySelector('input[name="password"]').value
            let deviceId = generateRandomId()
            if (!email || !password) return this.systemNotification.warning("Please enter email and password")

            let response = await fetch(reverseProxy['proxyUrl'] + '/operator/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-device-identifier': deviceId
                },
                body: JSON.stringify({ email, password })
            })

            try {
                let jsonRes = await response.json();

                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message)

                    return jsonRes
                } else {
                    if (jsonRes.data.isregisterVerified == 0) {

                        this.rigisterForm.makeVerfiyOTPForm(email, jsonRes.data, true)

                        return

                    } else if (jsonRes.data.isregisterVerified == 1) {

                        this.rigisterForm.makeRegisterForm(email)

                        return

                    } else if (jsonRes.data.isregisterVerified == 2) {
                        let db = new IndexDb()
                        await db.storeKeys(jsonRes.publicKey)
                        localStorage.setItem("deviceId", deviceId)
                        localStorage.setItem("x-access-token", jsonRes.data.token)
                        history.replaceState(null, null, proxy.production + "/operator");
                        window.location.href = proxy.production + '/operator'
                    }
                }

            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err))
            }

        })

        forgotBtn.addEventListener('click', e => {
            e.preventDefault()

            let forgotContainer = this._makeforgotUi(loginForm)

            this.addEventsToForgot(forgotContainer)

        })


        registerBtn.addEventListener('click', e => {
            e.preventDefault()

            this.rigisterForm._init()

        })


    }

    _makeforgotUi(loginForm) {

        document.querySelector('.login-add-on-buttons').style.display = "none"
        document.querySelector('.login-submit-button-container').style.display = "none"

        loginForm.innerHTML = `

            <label class="login-label-tag" for="email">Email Address</label>
            <div class="login-input-container" id='login_email_parent'>
                <input class="login-user-input" type="email" name="email" id="email" required placeholder="email@example.com">
                <div class='project-login-email-error-msgs'>
                    <i class='bx bxs-info-circle'></i>
                    <span id='email-error-msg'> Please enter your email address using the format name@example.com</span>
                </div>
            </div>

            <div class="login-submit-button-container send-otp-container-tab">
                <input name="login" id="reset" class="login-submit-button" type="submit" value="Send OTP">
            </div>
        
        `

        return loginForm

    }

    _makeVerifyOTPUI(forgotContainer, email) {

        forgotContainer.innerHTML = `
            <div class="form-group mb-4">
                <label for="password">OTP</label>
                <div id='inputs'>
                    <input id='input1' required class="optInput" type='text' maxLength="1" />
                    <input id='input2' required class="optInput" type='text' maxLength="1" />
                    <input id='input3' required class="optInput" type='text' maxLength="1" />
                    <input id='input4' required class="optInput" type='text' maxLength="1" />
                    <input id='input5' required class="optInput" type='text' maxLength="1" />
                    <input id='input6' required class="optInput" type='text' maxLength="1" />
                </div>
            </div>
            <p style="color: #000;float: right;"><a href="#!" class="text-reset" id="resendBtn">Resend OTP</a></p>
            <input name="login" id="optBtn" class="btn btn-block login-btn" type="submit" value="Verify OTP">
        `
        return forgotContainer
    }

    _makeResetPasswordUI(forgotContainer, email) {

        forgotContainer.innerHTML = `
            <div class="form-group">
                <label for="email">Email</label>
                <input type="email" name="email" id="email" value="${email}" disabled required class="form-control" placeholder="email@example.com">
            </div>
            <div class="form-group mb-4">
                <label for="password">Password</label>
                <input type="password" name="password" id="password" required class="form-control" placeholder="enter your passsword">
            </div>
            <input name="login" id="resetPassword" class="btn btn-block login-btn" type="submit" value="Reset Password">
        `
        return forgotContainer

    }

    addEventsToForgot(forgotContainer) {

        let input_email = forgotContainer.querySelector('#email')
        let resetBtn = forgotContainer.querySelector('#reset')
        let email_error_msgs = forgotContainer.querySelector('.project-login-email-error-msgs')

        function verifyEmail(value) {

            return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))

        }

        let email_events = () => {

            input_email.addEventListener("change", function () {

                if (!verifyEmail(input_email.value)) {
                    email_error_msgs.style.display = 'flex'

                    // if (!resetBtn.classList.contains('login-submit-button-disable')) resetBtn.classList.add('login-submit-button-disable')

                }
                else {
                    email_error_msgs.style.display = 'none'

                    // if (resetBtn.classList.contains('login-submit-button-disable')) resetBtn.classList.remove('login-submit-button-disable')
                }

            });
        }


        email_events()

        resetBtn.addEventListener('click', async (e) => {
            e.preventDefault()

            let email = forgotContainer.querySelector('input[name="email"]').value

            if (!email) return this.systemNotification.warning("Please enter email")

            let response = await fetch(reverseProxy['proxyUrl'] + '/operator/forget-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            })

            try {
                let jsonRes = await response.json();

                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message)
                    return jsonRes
                } else {
                    let verfiyOTPContainer = this._makeVerifyOTPUI(forgotContainer)
                    this.addEventsToVerifyOTP(verfiyOTPContainer, email)
                }

            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err))
            }

        })
    }

    addEventsToVerifyOTP(forgotContainer, email) {

        let optBtn = forgotContainer.querySelector('#optBtn')
        let resendBtn = forgotContainer.querySelector('#resendBtn')

        const inputs = ["input1", "input2", "input3", "input4", "input5", "input6"];

        inputs.map((id) => {
            const input = document.getElementById(id);
            addListener(input);
        });

        function addListener(input) {
            input.addEventListener("keyup", (event) => {
                const code = parseInt(input.value);
                if (code >= 0 && code <= 9) {
                    const n = input.nextElementSibling;
                    if (n) n.focus();
                } else {
                    input.value = "";
                }

                const key = event.key; // const {key} = event; ES6+
                if (key === "Backspace" || key === "Delete") {
                    const prev = input.previousElementSibling;
                    if (prev) prev.focus();
                }
            });
        }

        resendBtn.addEventListener('click', async (e) => {
            e.preventDefault()

            if (this.resendBtn) return

            if (!email) return this.systemNotification.warning("Please enter email")

            let response = await fetch(reverseProxy['proxyUrl'] + '/operator/resend-forget-password-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            })

            try {
                let jsonRes = await response.json();

                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message)
                    return jsonRes
                } else {
                    this.systemNotification.success(jsonRes.message)
                }

            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err))
            }

            this.countdown(forgotContainer)
            this.resendBtn = true
            e.target.classList.add("disabled");
        })

        optBtn.addEventListener('click', async (e) => {
            e.preventDefault()

            let otp = ""

            inputs.map((id) => {
                const input = document.getElementById(id);
                otp += input.value
            });

            if (!email || !otp) return this.systemNotification.warning("Please enter email and code")

            let response = await fetch(reverseProxy['proxyUrl'] + '/operator/verify-forgetPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email, code: otp })
            })

            try {
                let jsonRes = await response.json();

                if (!jsonRes.status) {
                    this.systemNotification.warning(jsonRes.message)
                    return jsonRes
                } else {
                    let resetPasswordContainer = this._makeResetPasswordUI(forgotContainer, email)

                    this.addEventsToResetPassword(resetPasswordContainer, email)
                }

            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err))
            }

        })

    }

    countdown(container) {
        var seconds = 60;
        let tick = () => {
            const timeElement = container.querySelector("#resendBtn");
            seconds--;
            timeElement.innerHTML = "0:" + (seconds < 10 ? "0" : "") + String(seconds);
            if (seconds > 0) {
                setTimeout(tick, 1000);
            } else {
                timeElement.innerHTML = "Resend OTP";
                timeElement.classList.remove("disabled");
                this.resendBtn = false
            }
        }

        tick();
    }

    addEventsToResetPassword(forgotContainer, email) {

        let resetPasswordBtn = forgotContainer.querySelector('#resetPassword');

        resetPasswordBtn.addEventListener('click', async (e) => {
            e.preventDefault();

            let password = forgotContainer.querySelector('input[name="password"]').value;

            if (!email || !password) {
                return this.systemNotification.warning("Please enter email and password");
            }

            // Password must be at least 8 characters, include one number and one special character
            const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

            if (!passwordRegex.test(password)) {
                return this.systemNotification.warning("Password must be at least 8 characters long and include at least one number and one special character.");
            }

            let response = await fetch(reverseProxy['proxyUrl'] + '/operator/reset-Password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email, password })
            });

            try {
                let jsonRes = await response.json();

                if (!jsonRes.status) {
                    window.location.href = "/operator/login";
                } else {
                    this.systemNotification.warning("Password reset successfully");
                    window.location.reload();
                }

            } catch (err) {
                this.systemNotification.warning(JSON.stringify(err));
            }

        });
    }

}

export default LoginUiController;